var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drainage-link"},[_vm._m(0),_c('div',{staticClass:"btn",on:{"click":_vm.goWx}},[_vm._v(" 打开微信小程序 ")]),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx-logo"},[_c('img',{attrs:{"src":require("@/static/images/wx-logo.png")}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/static/images/logo.png")}}),_vm._v(" 聆云通 ")])])
}]

export { render, staticRenderFns }